import apiClient from "../api/apiClient";

export const fetchCustomerBackOrders = async (customerId, dateFrom, dateTo) => {
  let url = `/backorder-details?customerNo=${customerId}`;
  if (dateFrom) url += `&dateFrom=${dateFrom}`;
  if (dateTo) url += `&dateTo=${dateTo}`;

  return apiClient(url, {
    method: "GET",
  });
};

// services/backorderExcelService.js
export const fetchCustomerBackOrdersExcel = async (
  customerId,
  dateFrom,
  dateTo
) => {
  let url = `/backorder-excel?customerNo=${customerId}`;
  if (dateFrom) url += `&dateFrom=${dateFrom}`;
  if (dateTo) url += `&dateTo=${dateTo}`;

  return apiClient(url, {
    method: "GET",
  });
};
